import { render } from "./autoReply.vue?vue&type=template&id=1994579d"
import script from "./autoReply.vue?vue&type=script&lang=js"
export * from "./autoReply.vue?vue&type=script&lang=js"

import "./autoReply.vue?vue&type=style&index=0&id=1994579d&lang=scss"
script.render = render

export default script